import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';
import { LazyAnimatedRovoIcon } from '@atlassian/conversation-assistant-ui-components/ui/LazyAnimatedRovoIcon';

import { getMiniModalMaxSizeStyle } from '../../common/ui/utils/mini-modal-max-size';

const styles = cssMap({
	miniModalMainContainer: {
		width: '400px',
		borderRadius: token('radius.small'),
		backgroundColor: token('elevation.surface.raised'),
		boxShadow: token('elevation.shadow.overlay'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	rovoIcon: {
		width: '48px',
		height: '48px',
	},
});

export const MiniModalLoadingContent = ({
	topOffset,
	openAtMaxSize,
}: {
	topOffset: number;
	openAtMaxSize?: boolean;
}): JSX.Element => {
	const availableHeight =
		topOffset === 0 ? 'calc(100vh - 3.5rem - 3rem)' : `calc(100vh - ${topOffset}px)`;
	const maxSize = openAtMaxSize ? getMiniModalMaxSizeStyle(availableHeight) : undefined;
	return (
		<Box
			testId="conversation-assistant-mini-modal-main-container"
			xcss={styles.miniModalMainContainer}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- runtime-dynamic viewport dimensions
			style={
				maxSize
					? { width: maxSize.width, height: maxSize.height }
					: { height: `min(320px, calc(100vh - ${topOffset}px))` }
			}
		>
			<Box xcss={styles.rovoIcon}>
				<LazyAnimatedRovoIcon alt="" testId="rovo-loading-animation" />
			</Box>
		</Box>
	);
};
